import * as React from 'react';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';

import TableComplaints from './Components/Complaints';
import TableContactUsMessages from './Components/ContactUsMessages';
import TableAdvertises from './Components/Advertises';

export default function ContactUs() {
    return (
        <Tabs
            variant='plain'
            aria-label="Pricing plan"
            defaultValue={0}
            sx={{
                width: '100%',
                borderRadius: 'sm',
                // boxShadow: 'sm',
                overflow: 'auto',
                backgroundColor: '#FBFBFB',
            }}
        >
            <TabList
                disableUnderline
                tabFlex={1}
                size='lg'
                sx={{
                    width: '40% !important',
                    [`& .${tabClasses.root}`]: {
                        fontSize: 'sm',
                        fontWeight: 'lg',
                        bgcolor: '#FBFBFB',

                        [`&[aria-selected="true"]`]: {
                            color: 'primary.500',
                            bgcolor: '#F7F9FB',
                        },
                        [`&.${tabClasses.focusVisible}`]: {
                            // outlineOffset: '-4px',
                        },
                    },
                }}
            >
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    عام
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    الإعلانات
                </Tab>
                <Tab disableIndicator variant="soft" sx={{ flexGrow: 1 }}>
                    الشكاوي
                </Tab>
            </TabList>


            <TabPanel value={0} sx={{ backgroundColor: '#F7F9FB' }}>
                <TableContactUsMessages />
            </TabPanel>
            <TabPanel value={1} sx={{ backgroundColor: '#F7F9FB' }}>
                <TableAdvertises />
            </TabPanel>
            <TabPanel value={2} sx={{ backgroundColor: '#F7F9FB' }}>
                <TableComplaints />
            </TabPanel>
        </Tabs>
    )
}